import { Injectable } from '@angular/core';
import { UserCompanyService } from './userCompany.service';
import { CompanyService } from './company.service';
import { MenuItems } from '../shared/menu-items/menu-items';

@Injectable({
  providedIn: 'root'
})
export class PurchaseService {

  constructor(
    private userCompanyService: UserCompanyService,
    private companyService: CompanyService,
    private menuItems : MenuItems
  ) {

    this.userCompanyService.userCompany$.subscribe((userCompany: any) => {
      if (userCompany?.company?.delfi_report_max_requests && Number(userCompany?.company?.delfi_report_max_requests) > 0) {
        // this.menuItems.addToMenu('overview', { state: 'progetto-innovativo', name: 'Progetto d\'innovazione', type: 'link', icon: '', pagetitle: 'Progetto d\'innovazione' })
      }
    })

   }



}
